<template>
	<v-container fluid class="blue-grey lighten-5">
		<v-row class="font-weight-black black--text mx-2 my-5">
			<h2>شرح تغییرات نسخه های پازارپلاس</h2>
		</v-row>

		<v-row class="font-weight-bold black--text mx-2">
			<v-col cols="12" sm="12" v-for="(item, id) in items" :key="id">
				<v-row class="version font-weight-bold blue lighten-4 black--text pa-2" v-on:click="toggle(item)">
					<!-- {{ `&nbsp;&#x25BE;` }} -->
					{{ item.name }}
					{{ item.visible }}
				</v-row>
				<div class="version-item" :id="item.version" :style="item.style">
					<v-row class="font-italic-medium indigo--text text-darken-1 ps-2 mt-2 caption"> {{ item.date }} </v-row>

					<v-row class="font-italic-medium indigo--text text-darken-1 ps-2 mt-2" v-if="item.children.length > 0">شرح تغییرات</v-row>
					<ul class="font-weight-medium black--text ps-5 my-2 text-justify">
						<li class="mt-2" v-for="(detail, idx) in item.children" :key="idx">{{ detail.name }}</li>
					</ul>

					<v-row v-if="authenticated" class="font-italic-medium indigo--text text-darken-1 ps-2 mt-2">لیست درخواستها</v-row>
					<ul v-if="authenticated" class="font-weight-medium black--text ps-5 my-2 text-justify">
						<li class="mt-2" v-for="(detail, idx) in item.detail" :key="idx">{{ detail.serialNumber }} - {{ detail.title }}</li>
					</ul>
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	export default {
		name: "PazarVersions",
		computed: {
			authenticated() {
				// console.info(1, this.$store.state.isAuthenticated);
				return this.$store.state.isAuthenticated;
			},
			items() {
				// console.info(2);
				const pazarVersions = this.$store.state.pazarVersions;
				// console.info(pazarVersions);
				let versions = [];
				for (let index = 0; index < pazarVersions.length; index++) {
					const item = pazarVersions[index];
					let description = [];
					// for (let index = 0; index < item.detail.length; index++) {
					// 	const child = item.detail[index];
					// 	description.push({
					// 		id: child.serialNumber,
					// 		name: child.title,
					// 	});
					// }

					if (item.description && item.description.length > 0) {
						let details = item.description.split("\n");
						// console.info(details);
						for (let j = 0; j < details.length; j++) {
							const element = details[j];
							let detail = element.trim();
							if (detail.length > 0) {
								description.push({
									id: `${index + 1}${j + 1}`,
									name: detail,
								});
							}
						}
					}
					versions.push({
						id: index + 1,
						version: item.version,
						// visible: index == 0 ? true : false,
						name: `ورژن ${item.version}`,
						// name: `ورژن ${item.version}   -  ${item.localDate}`,
						date: item.localDate,
						detail: item.detail,
						children: description,
						style: index == 0 ? "display: block" : "display: none",
						// arrowLable: '&nbsp;&#x25BE;', //'&nbsp;&#x25B4;'
					});
				}
				// console.info(versions);

				return versions;
			},
		},
		// watch: {
		// 	items: function () {
		// 		let itemsArr = document.getElementsByClassName("version-item");
		// 		console.info(itemsArr.length);
		// 		for (let index = 0; index < itemsArr.length; index++) {
		// 			// console.info(index);
		// 			itemsArr[index].style.display = index == 0 ? "block" : "none";
		// 		}
		// 	},
		// },
		// mounted: function () {
		// 	// console.info("mounted.");
		// 	this.$nextTick(function () {
		// 		let itemsArr = document.getElementsByClassName("version-item");
		// 		// console.info(itemsArr.length);
		// 		for (let index = 0; index < itemsArr.length; index++) {
		// 			// console.info(index);
		// 			itemsArr[index].style.display = index == 0 ? "block" : "none";
		// 		}
		// 	});
		// },
		methods: {
			toggle(item) {
				let itemsArr = document.getElementsByClassName("version-item");
				let itemEl = document.getElementById(item.version);
				for (let index = 0; index < itemsArr.length; index++) {
					if (itemEl == itemsArr[index]) {
						itemEl.style.display = itemEl.style.display === "none" ? "block" : "none";
					} else {
						// itemsArr[index].style.display = "none";  // Close other Items
					}
				}
			},
		},
	};
</script>
<style>
	.version {
		cursor: pointer;
	}
</style>
